import { FC, MouseEventHandler } from 'react';

interface IUnitProps {
  children: React.ReactNode;
  isActive?: boolean;
  href: string;
  onClick: MouseEventHandler<HTMLAnchorElement>;
}

const Unit: FC<IUnitProps> = ({
  children,
  isActive = false,
  href,
  onClick,
}: IUnitProps) => {
  return (
    <a
      data-testid={`Pagination unit ${children}`}
      className={`tw-lf-button tw-size-8 tw-rounded tw-border-transparent tw-bg-transparent tw-text-sm hover:tw-border hover:tw-border-solid hover:tw-border-yellow-400 ${
        isActive ? 'tw-bg-yellow-600' : 'tw-border-transparent tw-font-normal'
      }`}
      href={href}
      onClick={onClick}
    >
      {children}
    </a>
  );
};

export default Unit;
